"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const utils_1 = require("@/common/utils/utils");
const PlanetaryTrackRewards_vue_1 = __importDefault(require("./PlanetaryTrackRewards.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'PlanetaryTrack',
    props: {
        val: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        rewards: {
            type: Object,
            required: true,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            range: (0, utils_1.range)(23),
        };
    },
    components: {
        PlanetaryTrackRewards: PlanetaryTrackRewards_vue_1.default,
    },
    methods: {
        getClass(idx) {
            return (idx === this.val) ? 'highlight' : '';
        },
    },
    computed: {
        icon() {
            switch (this.type) {
                case 'risingPlayer': return '^';
                case 'everyone': return '*';
                case 'mostTags': return '!';
                default: return '';
            }
        },
    },
});
